/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_DeferredInputs */

const de__field_deferred = /** @type {(inputs: _Field_DeferredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zurückgestellt`)
};

/**

* @param {_Field_DeferredInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_deferred = /** @type {((inputs?: _Field_DeferredInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_DeferredInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_deferred(inputs)
});